import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=7ba8decc&"
var script = {}
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=7ba8decc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports